import { Component } from '@angular/core';

import { ToastService } from './toast.service';

@Component({
  selector: 'toast-container',
  templateUrl: './toast.component.html',
  host: { class: 'celerity-toast-container' }
})
export class ToastsContainerComponent {
  constructor(public toastService: ToastService) {}
}
